export function handleOneTrustLoad() {
  if (globalThis.window === undefined || !('OneTrust' in globalThis.window)) return

  const $ot = globalThis.window.OneTrust as any

  if (!$ot?.IsAlertBoxClosedAndValid()) {
    const $ot_c00002 = document?.getElementById('ot-group-id-C0002') as HTMLInputElement
    const $ot_c00003 = document?.getElementById('ot-group-id-C0003') as HTMLInputElement
    const $ot_c00004 = document?.getElementById('ot-group-id-C0004') as HTMLInputElement

    if ($ot_c00002?.checked) {
      $ot_c00002.click()
    }

    if ($ot_c00003?.checked) {
      $ot_c00003.click()
    }

    if ($ot_c00004?.checked) {
      $ot_c00004.click()
    }
  }
}
